import { HttpEvent, HttpEventType } from '@angular/common/http';
import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { ImageTypes } from 'src/app/services/global-constants';
import { ImageuploadService } from 'src/app/services/imageupload.service';

@Component({
  selector: 'app-file-upload',
  templateUrl: './file-upload.component.html',
  styleUrl: './file-upload.component.scss'
})
export class FileUploadComponent {
  uploadingFile: boolean = false;
  uploadProgress: number = 0;
  @Input() label: string = '';
   @Input() accept = "*/*"
  @Input({ required: true }) imageType?: ImageTypes
  @Output() response: EventEmitter<any> = new EventEmitter();
  @ViewChild("uploadInput")
  uploadInput?:ElementRef

  constructor(
    private imageUploadService: ImageuploadService
  ) { }

  async handleFileUpload(event: any) {
    if (!this.imageType) {
      return;
    }
    this.uploadingFile = true;
    this.imageUploadService.uploadImageWithProgress(event.target.files[0], this.imageType).subscribe({
      next: (event: HttpEvent<any>) => {
        switch (event.type) {
          case HttpEventType.UploadProgress:
            this.uploadProgress = Math.round(event.loaded / event.total! * 100);
            break;
          case HttpEventType.Response:
            if (event.ok) {
              this.response.emit(event.body.data);
              setTimeout(() => {
                this.uploadProgress = 0;
              }, 1500);
            } else {
              let obj: any = {
                message: "Failed to upload file",
                error: true
              }
              this.response.emit(obj)
            }

        }
      },
      error: (error) => {
        console.log('UPLOAD ERROR', error);
        this.uploadingFile = false;
        this.uploadProgress = 0;
        let obj: any = {
          message: "Failed to upload file",
          error: true
        }
        this.response.emit(obj)
      },
      complete: () => {
        this.uploadingFile = false;
        this.uploadProgress = 0;
      }
    })
  }
}
